var _URLSearchParams$get, _getPreviewJwt;
import { getIsThemePreview, getPreviewJwt } from 'portals-platform-lib';
const cachedPortalId = typeof window === 'undefined' ? '' : (_URLSearchParams$get = new URLSearchParams(window.location.search).get('portalId')) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : '';
const cached = getIsThemePreview() ? {
  isPreview: true,
  previewJwt: (_getPreviewJwt = getPreviewJwt()) !== null && _getPreviewJwt !== void 0 ? _getPreviewJwt : '',
  portalId: cachedPortalId
} : {
  isPreview: false,
  previewJwt: null,
  portalId: null
};
export const getIsPreview = () => cached;